const embeddedBasePageTemplate = require('../../embedded/embedded-base-page.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state(
            'embedded',
            {
                abstract: true,
                url: '/embedded',
                resolve: {
                    modules: [
                        '$ocLazyLoad', function ($ocLazyLoad) {
                            return $ocLazyLoad.load('embedded');
                        },
                    ],
                },
                views: {
                    '@': {
                        template: embeddedBasePageTemplate,
                    },
                },
            },
        )
        // login via agent
        .state(
            'embedded.loginviaagent',
            {
                url: '/loginviaagent?linktoken&uid',
                views: {
                    'embedded-base-content@embedded': {
                        controller: [
                            '$stateParams', 'EmbeddedService', function ($stateParams, embeddedService) {
                                this.linkToken = $stateParams.linktoken;
                                this.uid = $stateParams.uid;

                                embeddedService.getDetails(this.linkToken).then((res) => {
                                    this.companyName = res.CompanyName.toLowerCase();
                                });
                            },
                        ],
                        controllerAs: '$ctrl',
                        template: '<wow-embedded-login-form link-token="$ctrl.linkToken" uid="$ctrl.uid" template="$ctrl.template" company-name="$ctrl.companyName" ng-if="$ctrl.companyName"></wow-embedded-login-form>',
                    },
                },
            },
        )
        // signup via agent
        .state(
            'embedded.registerviaagent',
            {
                url: '/registerviaagent?linktoken&uid',
                views: {
                    'embedded-base-content@embedded': {
                        controller: [
                            '$stateParams', 'EmbeddedService', function ($stateParams, embeddedService) {
                                this.linkToken = $stateParams.linktoken;
                                this.uid = $stateParams.uid;

                                embeddedService.getDetails(this.linkToken).then((res) => {
                                    this.companyName = res.CompanyName.toLowerCase();
                                });
                            },
                        ],
                        controllerAs: '$ctrl',
                        template: '<wow-embedded-signup-form link-token="$ctrl.linkToken" uid="$ctrl.uid" company-name="$ctrl.companyName" ng-if="$ctrl.companyName"></wow-embedded-signup-form>',
                    },
                },
            },
        )
        // signup via agent confirmation
        .state(
            'embedded.registerviaagent.confirmation',
            {
                url: '/confirmation?name&email&mobile&birth&work&abn&company&address&shopperid&redirectToAgentUrl',
                views: {
                    'embedded-base-content@embedded': {
                        controller: [
                            '$stateParams', 'EmbeddedService', function ($stateParams, embeddedService) {
                                this.details = {
                                    signupName: $stateParams.name,
                                    signupEmail: $stateParams.email,
                                    signupMobile: $stateParams.mobile,
                                    signupWorkPhone: $stateParams.mobile,
                                    signupAbn: $stateParams.abn,
                                    signupCompanyName: $stateParams.company,
                                    signupAddress: $stateParams.address,
                                    signupBirth: $stateParams.birth,
                                    redirectToAgentUrl: $stateParams.redirectToAgentUrl,
                                };

                                this.linkToken = $stateParams.linktoken;

                                embeddedService.getDetails(this.linkToken).then((res) => {
                                    this.companyName = res.CompanyName.toLowerCase();
                                });
                            },
                        ],
                        controllerAs: '$ctrl',
                        template: '<wow-embedded-signup-confirmation details="$ctrl.details" link-token="$ctrl.linkToken" company-name="$ctrl.companyName" ng-if="$ctrl.companyName"></wow-embedded-signup-confirmation>',
                    },
                },
            },
        );
};



// WEBPACK FOOTER //
// ./src/configuration/routes/embedded.js